<template>
    <div class="tablet-sm:mx-auto text-base leading-7 text-gray-700 w-full">
        <slot></slot>
    </div>
</template>
